/**
 * Ratification writes the agreed closing date to offerSpecifics; the timeline
 * copy is only the original offer's, and is often empty.
 */
export function contractClosingDate(
  contract:
    | {
        offerSpecifics?: { closingDate?: string };
        timeline?: { closingDate?: string };
        agentOfferInfo?: { closingDate?: string };
      }
    | null
    | undefined
): string | undefined {
  return (
    contract?.offerSpecifics?.closingDate ||
    contract?.timeline?.closingDate ||
    contract?.agentOfferInfo?.closingDate ||
    undefined
  );
}
